module.exports = __webpack_public_path__ + "static/img/zp_12.5d5a8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zp_12.png
// module id = 7boV
// module chunks = 4